var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"forgot-password-view"},[_c('div',{staticClass:"content"},[_vm._v("\n    "+_vm._s(_vm.$t('login-modal_reset_link_sent_to'))+"\n    "),_c('i',{staticClass:"has-text-danger"},[_vm._v(_vm._s(_vm.email))]),_vm._v("."+_vm._s(_vm.$t('login-modal_click_email_link_to_reset'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }